import React from 'react';
import { Check } from 'lucide-react';
export function PricingTable() {
  const packages = [{
    name: 'Interior Only',
    price: '199',
    priceXL: '219',
    features: ['Glass cleaned', 'Doors & sills wiped', 'Carpets & mats shampooed', 'Seats cleaned & conditioned', 'Vacuum entire interior', 'Plastics cleaned & protected'],
    highlight: false
  }, {
    name: 'Exterior Only',
    price: '199',
    priceXL: '219',
    features: ['Full exterior hand wash', 'Wheels deep cleaned', 'Tires dressed & protected', 'Chrome polish', 'Spray wax application', 'Windows cleaned exterior'],
    highlight: false
  }, {
    name: 'Gold Package',
    price: '269',
    priceXL: '299',
    features: ['Everything in Interior Only', 'Everything in Exterior Only', 'Machine buff & polish', 'Leather conditioning', 'UV protection for all surfaces'],
    highlight: false
  }, {
    name: 'Platinum Package',
    price: '599',
    priceXL: '699',
    features: ['Everything in Gold Package', 'Clay bar treatment', 'Iron decontamination', '1-Year Ceramic Coating', 'Engine bay detail', 'Headlight restoration'],
    highlight: true
  }];
  return <section id="pricing" className="py-20 md:py-32 bg-[#F9F9F9]" data-id="element-121">
      <div className="container mx-auto px-4 md:px-6" data-id="element-122">
        <div className="text-center mb-16" data-id="element-123">
          <h2 className="text-3xl md:text-5xl font-black text-[#111111] uppercase mb-4" data-id="element-124">
            Transparent Pricing. No Surprises.
          </h2>
          <p className="text-base md:text-lg text-gray-600 font-medium" data-id="element-125">
            Car / Mid-Size Truck (2 Rows){' '}
            <span className="mx-2 text-[#7FD4D4]" data-id="element-126">|</span> SUV / XL Truck (3
            Rows)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-start" data-id="element-127">
          {packages.map((pkg, index) => <div key={index} className={`relative bg-white rounded-sm p-6 md:p-8 flex flex-col h-full transition-all duration-300 ${pkg.highlight ? 'border-2 border-[#7FD4D4] shadow-2xl md:scale-105 z-10' : 'border border-gray-200 shadow-lg hover:shadow-xl'}`} data-id="element-128">
              {pkg.highlight && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#7FD4D4] text-black text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full shadow-md" data-id="element-129">
                  Most Popular
                </div>}

              <div className="mb-8 text-center" data-id="element-130">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-131">
                  {pkg.name}
                </h3>
                <div className="flex items-center justify-center text-gray-900 mb-1" data-id="element-132">
                  <span className="text-xl md:text-2xl font-bold" data-id="element-133">$</span>
                  <span className="text-4xl md:text-5xl font-black tracking-tighter" data-id="element-134">
                    {pkg.price}
                  </span>
                </div>
                <div className="text-gray-500 font-medium text-sm" data-id="element-135">
                  / ${pkg.priceXL} for XL
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-136">
                {pkg.features.map((feature, i) => <li key={i} className="flex items-start text-sm text-gray-700" data-id="element-137">
                    <Check className="w-5 h-5 text-[#7FD4D4] mr-3 flex-shrink-0" data-id="element-138" />
                    <span data-id="element-139">{feature}</span>
                  </li>)}
              </ul>

              <a href="#booking" className={`w-full py-4 font-bold uppercase tracking-wide text-sm text-center rounded-sm transition-colors min-h-[44px] flex items-center justify-center ${pkg.highlight ? 'bg-[#7FD4D4] text-black hover:bg-[#6BC4C4]' : 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'}`} data-id="element-140">
                Book This Package
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}